import { useState, useEffect } from 'react';
import Button from '../base/Button';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900/95 backdrop-blur-md border-t border-gray-700/50 p-4 sm:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-start space-x-3">
              <i className="ri-cookie-line text-blue-400 text-xl mt-1 flex-shrink-0"></i>
              <div>
                <h3 className="text-white font-semibold mb-1">Çerez Kullanımı</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Web sitemizde deneyiminizi geliştirmek için çerezler kullanıyoruz. 
                  Siteyi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.
                  <button 
                    className="text-blue-400 hover:text-blue-300 underline ml-1"
                    onClick={() => {
                      // Çerez politikası sayfasına yönlendirme
                      console.log('Çerez politikası sayfası açılacak');
                    }}
                  >
                    Detaylı bilgi
                  </button>
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex space-x-3 flex-shrink-0">
            <button
              onClick={rejectCookies}
              className="px-4 py-2 text-gray-300 hover:text-white border border-gray-600 hover:border-gray-500 rounded-lg transition-colors duration-300 text-sm whitespace-nowrap"
            >
              Reddet
            </button>
            <Button
              onClick={acceptCookies}
              size="sm"
              className="whitespace-nowrap"
            >
              Kabul Et
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}